import * as C from "../constants"
import { createReducer} from "../utils/misc";

const initialState= {
    token: null,
    username: null,
    isAuthenticated: false,
    isAuthenticating: false,
    isMasterOrganization: false,
    statusText: null,
    fullName: null,
    role: null,
    isResetPassRequested: false,
    isResetPAssRequesting: false,
};

export default createReducer(initialState,{
    [C.LOGIN_USER_REQUEST]: (state) => ({
        ...state,
        isAuthenticating: true,
        statusText: null,
    }),
    [C.LOGIN_USER_SUCCESS]: (state, payload) => ({
        ...state,
        isAuthenticated: true,
        isAuthenticating: false,
        token: payload.token,
        username: payload.username,
        role: payload.role,
        name: payload.name,
        isMasterOrganization: payload.isMasterOrganization,
        statusText: "Вы успешно вошли."
    }),
    [C.LOGIN_USER_FAILURE]: (state, payload) => ({
        ...state,
        isAuthenticating: false,
        isAuthenticated: false,
        token: null,
        username: null,
        role: null,
        name: null,
        isMasterOrganization: false,
        statusText: `Ошибка аутентификации: ${payload.status} ${payload.statusText}.`,
    }),
    [C.LOGOUT_USER]: (state) => ({
        ...state,
        isAuthenticated: false,
        token: null,
        username: null,
        role: null,
        name: null,
        isMasterOrganization: false,
        statusText: "Вы успешно вышли."
    }),
    [C.RESET_PASSWORD_REQUEST]: (state) => ({
        ...state,
        isResetPAssRequesting: true
    }),
    [C.RESET_PASSWORD_FAILURE]: (state, payload) => ({
        ...state,
        isResetPassRequested: false,
        isResetPAssRequesting: false,
        statusText: `Ошибка сброса пароля: ${payload.status} ${payload.statusText}.`
    }),
    [C.RESET_PASSWORD_SUCCESS]: (state) => ({
        ...state,
        isResetPassRequested: true,
        isResetPassRequesting: false,
        statusText: null,
    })
})




// WEBPACK FOOTER //
// ./src/reducers/auth.js